import * as HLF from "html-living-framework";
import * as PIXI from "pixi.js";
import {BaseButton} from "../core/Button";
import {ContainerExtensions} from "../core/ContainerExtensions";
import {IRectangle} from "../core/Geom";
import {KeyboardFocusLayer} from "./KeyboardFocusLayer";

export const Focusable = {
    getFocusPosition(this: PIXI.Container): PIXI.Point {
        if (this.transform) {
            const bounds = ContainerExtensions.getGlobalBounds.call(this);
            return new PIXI.Point(bounds.x + bounds.width / 2, bounds.y + bounds.height / 2);
        }
        return new PIXI.Point();
    },
    getFocusSize(this: PIXI.Container): PIXI.Point {
        if (this.transform) {
            const bounds = ContainerExtensions.getGlobalBounds.call(this);
            return new PIXI.Point(bounds.width, bounds.height);
        }
        return new PIXI.Point();
    },
    onFocusActivated(this: BaseButton): void {
        if (this.enabled && this.worldVisible && !this.getAncestor((it) => !it.interactiveChildren)) {
            if (this.onClick) {
                this.onDown(this);
                this.onClick(this);
                if (this.toggle) {
                    this.selected = !this.selected;
                    this.onChange(this, this.selected);
                }
            }
        }
    },
    onFocusBegin(this: HLF.Input.IFocusable & BaseButton): void {
        KeyboardFocusLayer.instance.currentFocusable = this;
        this.onOver(this);
    },
    onFocusEnd(this: BaseButton): void {
        KeyboardFocusLayer.instance.currentFocusable = undefined;
        this.onOut(this);
    },
};

export interface IFocusableRect extends HLF.Input.IFocusable {
    getFocusRect?(): IRectangle;
}
